var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      attrs: { id: _vm.id },
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm.isSvg
        ? _c("inline-svg", {
            class: _vm.getSvgClasses,
            attrs: {
              src: _vm.src,
              width: _vm.width || _vm.getSize.width,
              height: _vm.height || _vm.getSize.height
            },
            on: { loaded: _vm.svgLoaded }
          })
        : _c("img", {
            attrs: { src: _vm.src, width: _vm.width || _vm.getSize.width }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71129cfd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71129cfd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/BaseIcon.vue
// module id = 1661
// module chunks = 116